(ns app.domain.location.model)


(defn- valid-x-y? [x y]
  (not (or (nil? x) (nil? y) (zero? x) (zero? y) (NaN? x) (NaN? y))))


(defn center-coords-pair-in-epsg-3857 [{:location.center/keys [x y]}]
  (when (valid-x-y? x y)
    [x y]))


(defn property-location->center-coords
  [property]
  (when-let [location (-> property :entity/location)]
    (center-coords-pair-in-epsg-3857 location)))
